import 	React, { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";

import { getProposal } from "store/actions/proposal";
import { COLUMN_HEADER_KEYS } from "globals/constants";
import { useDictionary, useFormAccesses } from "hooks";
import TeamMemberAssignment from "containers/Fragments/TeamMemberAssignment";
import { proposalSelectors } from "store/selectors";


const AccessView = () => {
	const proposal = useSelector(proposalSelectors.proposal);
	const teamAccess = useMemo(() => {
		return proposal.userAccesses;
	}, [ proposal ]);
	const dictionary = useDictionary("proposalDetails.adminTeam");

	const formAccesses = useFormAccesses(COLUMN_HEADER_KEYS.PROPOSAL, proposal.proposalId);

	const onAdminTeamSaved = useCallback(() => {
		return getProposal(proposal.proposalId, { isRefresh: true });
	}, [ proposal.proposalId ]);

	return (
		<div data-component="Proposal\Detail\AdminTeamView">
			<TeamMemberAssignment
				canEdit={formAccesses.updateAdminTeam}
				dictionary={dictionary}
				teamMembers={teamAccess}
				formId={proposal.proposalId}
				formType={COLUMN_HEADER_KEYS.PROPOSAL}
				onSave={onAdminTeamSaved}
			/>
		</div>
	);
};

export default AccessView;
